import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

const withRouter = (WrappedComponent) => (props) => {
  return (
    <WrappedComponent
      {...props}
      params={useParams()}
      location={useLocation()}
      navigate={useNavigate()}
    />
  );
};

export default withRouter;
